module.exports = __webpack_public_path__ + "static/media/approve.9fddda6e.svg";